module.exports = __webpack_public_path__ + "static/media/team-3.e4dd1b18.jpg";